import { LinearProgress } from "@mui/material";

interface IGPTableLoader {
    loading?: boolean;
}

function GPTableLoader({ loading }: IGPTableLoader) {
    if (!loading) {
        return null;
    }

    return (
        <LinearProgress
            color="secondary"
            sx={{ position: "absolute", zIndex: 999, width: "100%" }}
        />
    );
}

GPTableLoader.defaultProps = {
    loading: false,
};

export default GPTableLoader;
